export function reactLinker(urlManager) {
    return {
        href: urlManager.href,
        onClick: (ev) => {
            if (!urlManager?.detached) {
                ev?.preventDefault();
            }
            urlManager.go();
        },
    };
}
